import { useState, useEffect } from 'react';
import { Grid, InputBase, CardActionArea, Tooltip } from '@mui/material';
import { ColorPicker } from '../../../../../Global/Components';
import { grey } from '@mui/material/colors';
import { useHistory } from 'react-router-dom';
import { isArray } from 'lodash';
import useElementSize from '../../../../../Global/hooks/useElementSize';
import { TooltipTypography } from '../../../../../Global/Components';
import { FolderRounded } from '@mui/icons-material';
import { v4 } from 'uuid';
import MenuList from '../MenuList';

export default function FolderItem({ data, editable, onDelete, onEdit, onChange }) {
  const history = useHistory();
  const [title, setTitle] = useState('');
  const [colorPicker, setColorPicker] = useState(null);
  const [color, setColor] = useState(null);
  const [elementId] = useState(v4());
  const { height, width } = useElementSize(elementId);
  const [fontSettings, setFontSettings] = useState({});
  const fontSizeCoefficient = fontSettings?.size
    ? fontSettings.size === '24px'
      ? [2, 3]
      : fontSettings.size === '16px'
      ? [4, 6]
      : fontSettings.size === '10px'
      ? [8, 16]
      : [4, 6]
    : [4, 6];
  const fontSize = Math.min(height / fontSizeCoefficient[0], width / fontSizeCoefficient[1]);

  function saveColor(color) {
    setColor(color);
    onEdit({ color, title, folder: data?.folder });
  }

  function saveFontSettings(settings) {
    setFontSettings(settings);
    onChange({ fontSettings: settings });
  }

  useEffect(() => {
    setTitle(data?.title || '');
    setColor(data?.color || null);
    setFontSettings(data?.fontSettings || {});
  }, [data]);

  function onClick() {
    let link = '/DocLibrary/areas';
    if (!data?.folder) return;
    if (data?.folder?.area && !data.folder?.folder) {
      link = `${link}/${data?.folder?.area}`;
    }
    if (data?.folder?.area && data.folder?.folder) {
      link = `${link}/${data?.folder?.area}/${data.folder?.folder}`;
    }
    history.push(link);
  }

  return (
    <Grid container style={{ height: '100%' }} id={elementId}>
      {editable ? (
        <Grid container alignItems="center" wrap="nowrap" sx={{ p: 1 }}>
          <FolderRounded style={{ color: grey[700] }} />
          <InputBase
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
              onEdit({ title: e.target.value, color, folder: data?.folder });
            }}
            onMouseDown={(e) => e.stopPropagation()}
            placeholder="Enter title"
            inputProps={{ maxLength: 256, style: { fontSize: 20 } }}
            style={{ marginLeft: 16, fontSize: 20 }}
          />
          <Tooltip title="Change color" placement="top"></Tooltip>
          <ColorPicker
            anchor={colorPicker}
            open={Boolean(colorPicker)}
            column={400}
            customPicker
            onClose={(res) => {
              if (res?.color) {
                saveColor(res?.color);
              }
              setColorPicker(null);
            }}
            className="non-draggable"
          />
          <MenuList
            mode={'header'}
            onDelete={onDelete}
            setColorPicker={setColorPicker}
            color={color}
            onChange={onChange}
            fontSettings={fontSettings}
            saveFontSettings={saveFontSettings}
          />
        </Grid>
      ) : (
        <CardActionArea
          style={{ padding: 16, height: '100%', width: '100%', borderRadius: 5, background: color }}
          onClick={onClick}
        >
          <Grid
            container
            style={{ height: '100%' }}
            alignItems="center"
            wrap="nowrap"
            justifyContent={fontSettings?.alignment || 'center'}
          >
            <FolderRounded style={{ color: grey[700] }} />
            <TooltipTypography style={{ marginLeft: 16, fontSize }} noWrap>
              {title ? title : isArray(data?.folder?.path) ? data.folder.path.join('/') : ''}
            </TooltipTypography>
          </Grid>
        </CardActionArea>
      )}
    </Grid>
  );
}
